import * as actionTypes from '../constants/actionTypes';
import axios from '../../../../shared/axios/axios';

import { validateObj } from '../../../../shared/utils';

const getCustomFormStart = () => {
  return {
    type: actionTypes.CUSTOM_FORM_GET_CUSTOM_FORM_FORM_START,
  };
};

const getCustomFormSuccess = (data) => {
  return {
    type: actionTypes.CUSTOM_FORM_GET_CUSTOM_FORM_FORM_SUCCESS,
    data,
  };
};

const getCustomFormFail = (error) => {
  return {
    type: actionTypes.CUSTOM_FORM_GET_CUSTOM_FORM_FORM_FAIL,
    error,
  };
};

export const getCustomForm = (request) => {
  return (dispatch) => {
    dispatch(getCustomFormStart());
    const url = `/custom-form/get-custom-form`;

    axios
      .get(url, { params: validateObj(request), responseType: 'blob' })
      .then((response) => {
        new Response(response.data).arrayBuffer().then((result) => dispatch(getCustomFormSuccess(result)));
      })
      .catch((err) => dispatch(getCustomFormFail(err)));
  };
};

const updateFormStart = () => {
  return {
    type: actionTypes.CUSTOM_FORM_UPDATE_FORM_START,
  };
};

const updateFormSuccess = (data) => {
  return {
    type: actionTypes.CUSTOM_FORM_UPDATE_FORM_SUCCESS,
    data,
  };
};

const updateFormFail = (error) => {
  return {
    type: actionTypes.CUSTOM_FORM_UPDATE_FORM_FAIL,
    error,
  };
};

export const updateForm = (request) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateFormStart());
      const url = `/custom-form/update-form`;

      axios
        .put(url, validateObj(request))
        .then((response) => {
          dispatch(updateFormSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(updateFormFail(err));
          reject(err);
        });
    });
  };
};

const getMappingObjectNamesStart = () => {
  return {
    type: actionTypes.CUSTOM_FORM_GET_OBJECT_NAMES_START,
  };
};

const getMappingObjectNamesSuccess = (data) => {
  return {
    type: actionTypes.CUSTOM_FORM_GET_OBJECT_NAMES_SUCCESS,
    data,
  };
};

const getMappingObjectNamesFail = (error) => {
  return {
    type: actionTypes.CUSTOM_FORM_GET_OBJECT_NAMES_FAIL,
    error,
  };
};

export const getMappingObjectNames = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getMappingObjectNamesStart());
      const url = `/custom-form/get-mapping-object-names`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getMappingObjectNamesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getMappingObjectNamesFail(err));
          reject(err);
        });
    });
  };
};

const getMappingsStart = () => {
  return {
    type: actionTypes.CUSTOM_FORM_GET_MAPPINGS_START,
  };
};

const getMappingsSuccess = (data) => {
  return {
    type: actionTypes.CUSTOM_FORM_GET_MAPPINGS_SUCCESS,
    data,
  };
};

const getMappingsFail = (error) => {
  return {
    type: actionTypes.CUSTOM_FORM_GET_MAPPINGS_FAIL,
    error: error,
  };
};

export const getMappings = (params) => {
  return (dispatch) => {
    dispatch(getMappingsStart());
    const url = `/custom-form/get-mappings`;

    axios
      .get(url, { params: validateObj(params) })
      .then((response) => dispatch(getMappingsSuccess(response.data)))
      .catch((err) => dispatch(getMappingsFail(err)));
  };
};
